import Col from 'react-bootstrap/Col'
import Image from 'next/image'
import ArticleTagsRead from "../Article/ArticleTagsRead"
import ArticlePubProfile from "../Article/ArticlePubProfile"
import blogStyles from '../../styles/Blog.module.css'
import { cloudfront } from "../../config"
import Link from "next/link"


export default function BlogItem(props) {
    return(
        <Col lg={4} md={6} sm={12} className="h-100 text-dark pb-5">
            <Link href={`/blog/article/${props.article.article_slug}`} passHref>
                <a className='text-deco'>
                    <Image 
                        className={blogStyles.thumbnail} 
                        src={`${cloudfront}/media/${props.article.article_image}`} 
                        width={328} 
                        height={170} 
                        layout='responsive' 
                        objectFit="cover"
                        alt={props.article.article_title} 
                    />
                    <ArticlePubProfile 
                        published={props.article.article_published} 
                        profile={props.article.main_profile} 
                    />
                    <h4 className={blogStyles.article_title}>{props.article.article_title}</h4>
                    <ArticleTagsRead 
                        article_tags={props.article.main_tag} 
                        reading_time={props.article.reading_time}
                    />
                </a>
            </Link>
        </Col>
    )
}